import axios, { AxiosResponse } from 'axios'

export { MfaWaitError } from './errors'
export { FactorType } from './enums'
export { default as requestChallenge } from './requestChallenge'
export { default as verifyFactor } from './verifyFactor'
export { default as enrollFactor } from './enrollFactor'
export { default as getFactor } from './getFactor'
export { default as getFactors } from './getFactors'

export interface MfaErrorData {
    type: string
    code: string
}

let navigateTimer: ReturnType<typeof setTimeout> | null = null

function navigateOnce(hashPath: string) {
    // To prevent multiple requests entering and wanting
    // to redirect at the same time, set a timer that is
    // cleared if entered within 250ms of timer being set.
    if (navigateTimer !== null) {
        clearTimeout(navigateTimer)
    }

    navigateTimer = setTimeout(() => {
        navigateTimer = null
        const redirectToHash = `#${hashPath || '/'}`

        if (redirectToHash && redirectToHash !== window.location.hash) {
            window.location.hash = redirectToHash
        }
    }, 250)
}

function isMfaResponse(
    status: number,
    { type, code }: MfaErrorData,
    mfaCode: string,
): boolean {
    return status === 403 && type === 'mfa' && code === mfaCode
}

export function handleMfaResponse(
    status: number,
    errorData: MfaErrorData,
): boolean {
    let redirectToHash: string | undefined

    if (isMfaResponse(status, errorData, 'verification_required')) {
        redirectToHash = '/auth/mfa/verify'
    } else if (isMfaResponse(status, errorData, 'enrollment_required')) {
        redirectToHash = '/auth/mfa/enroll'
    }

    if (redirectToHash) {
        navigateOnce(redirectToHash)

        return true
    }

    return false
}

export function registerMfaErrorResponseHandler() {
    axios.interceptors.response.use(undefined, (error) => {
        const response = error.response as AxiosResponse
        const errorData = response.data as MfaErrorData

        if (handleMfaResponse(response.status, errorData)) {
            return
        }

        throw error
    })
}
